/*
 * @description: el-dialog构造函数
 * @Author: wxy
 * @Date: 2019-02-15 15:12:40
 */

import Vue from 'vue'
import ElDialog from 'element-ui/lib/dialog'

// import { Dialog } from 'element-ui'
// Vue.use(Dialog)

let DialogExtend = Vue.extend({
  name: 'dialogs',
  template: `<el-dialog ref="dialog"  :class="options.type" :title='options.title' :visible.sync='dialogVisible' :width='options.width' :close-on-click-modal="options.closeOnClickModal" :close-on-press-escape="options.closeOnPressEscape" @closed="closed">
    <component ref="childComponent" :is = 'content' :data='data'></component>
</el-dialog>`,
  data () {
    return {
      options: {
        title: '',
        width: '',
        type: 'info',
        closeOnClickModal: true,
        closeOnPressEscape: true
      },
      data: null,
      content: '',
      dialogVisible: false
    }
  },
  components: { ElDialog },
  methods: {
    closed () { // 关闭后删除弹窗
      let child = this.$refs.dialog.$el
      document.getElementsByTagName('body')[0].removeChild(child)
    }
  },
  created () {}
})

class DialogInterface {
  constructor () {
    this.dialog = new DialogExtend()
    // this.parentId=parentId || 'dialog-wrap'
    this.defer = null
    this.defaultOptions = {
      title: '提示',
      width: '35%',
      type: 'info',
      closeOnClickModal: true
    }
    document.body.appendChild(this.dialog.$mount().$el)
  }
  reset () {
    this.dialog.dialogVisible = false
    this.dialog.content = ''
    this.dialog.data = null
    this.dialog.options = this.defaultOptions
    this.defer = null
  }

  open (content, data_, options) {
    // if(this.parentId && document.getElementById(this.parentId)){
    //   this.dialog.$mount(`#${this.parentId}`)
    //
    // }
    this.defer = this.Defer()
    this.dialog.dialogVisible = true
    this.dialog.content = content
    this.dialog.data = data_
    Object.assign(this.dialog.options, options)
    Vue.nextTick(() => {
      this.dialog.$refs.childComponent.initData(data_)
    })
    return this.defer.promise
  }

  Defer () {
    let resolve, reject
    let promise = new Promise(function(resolve_, reject_) {
      resolve = resolve_
      reject = reject_
    })
    return {
      promise,
      resolve,
      reject
    }
  }

  confirm (data) {
    if (this.defer.resolve) {
      this.defer.resolve(data)
    }
    this.reset()
  }

  cancel (data) {
    if (this.defer.reject) {
      this.defer.reject(data)
    }
    this.reset()
  }
}

export { DialogInterface }



// WEBPACK FOOTER //
// ./src/utils/dialogInterface.js